export const environment = {
  production: false,
  isStaging: true
};
